import modalService from '@/modules/modals/services/modal.service';
import WCAddToListModal from '@/modules/lists/components/WCAddToListModal/WCAddToListModal.vue';
import ItemAddToListMixin from '@/modules/lists/mixins/ItemAddToListMixin';

export default {
  mixins: { ItemAddToListMixin },
  methods: {
    /**
     * To open Add to list modal
     */
    async openAddToListModal(checkedItems) {
      this.$emit('close');
      try {
        await modalService.open(WCAddToListModal, {
          items: checkedItems.map(item => ({
            ...item,
            type: 1,
            variation: item.variation ? item.variation.id : null,
          })),
        });
      } catch (error) {
        // NOOP
        console.error(error);
      } finally {
        if (this.$refs.addSelectedToListModalBtnRef)
          this.$refs.addSelectedToListModalBtnRef.focus();
      }
    },
    /**
     * Method to add all selected items to list
     * @param {Array} checkedItems
     */
    addSelectedToList(checkedItems) {
      if (!this.isGuest) {
        this.openAddToListModal(checkedItems);
      } else {
        this.$router.push('/login');
      }
    },
  },
};
